import React from 'react';
import { string, number, func, shape } from 'prop-types';
import classnames from 'classnames';

import { Image } from '@thd-olt-component-react/core-ui';
import './PackagePodMessage.scss';

export const PackagePodMessage = ({
  product, onClick, onCloseClick
}) => {
  const messagingActionClasses = classnames('package-pod-message__messaging__action', 'u__default-link');
  const { brandName, productLabel } = product.identifiers || {};
  const { value: price } = product.pricing || {};
  const isNoMapPolicy = product?.pricing?.mapDetail?.mapPolicy === null;
  return (
    <div className="package-pod-message">
      <Image
        width="15"
        height="15"
        alt=""
        src="https://assets.thdstatic.com/images/v1/success.svg"
        className="package-pod-message__image"
      />
      <div className="package-pod-message__messaging">
        <span className="package-pod-message__messaging__main u__bold">Model Successfully Swapped</span>
        <span className="package-pod-message__messaging__info">
          {brandName && productLabel && (<><span className="u__bold">Prior Model</span> {brandName} {productLabel}</>)}
          {isNoMapPolicy && price && <span className="u__bold"> ${price}</span>}
          <span className={messagingActionClasses} role="button" tabIndex="0" onClick={onClick}>  Swap&nbsp;Back</span>
        </span>
      </div>
      {onCloseClick && (
        <Image
          width="15"
          height="15"
          alt="Close Message"
          src="https://assets.thdstatic.com/images/v1/close-symbol.svg"
          className="package-pod-message__image package-pod-message__image--close"
          onClick={onCloseClick}
        />
      )}
    </div>
  );
};

PackagePodMessage.displayName = 'PackagePodMessage';

PackagePodMessage.propTypes = {
  product: shape({
    identifiers: shape({
      brandName: string,
      productLabel: string,
    }),
    pricing: shape({
      value: number,
    }),
  }),
  onClick: func,
  onCloseClick: func,
};

PackagePodMessage.defaultProps = {
  product: {},
  onClick: null,
  onCloseClick: null,
};
